import PropTypes from 'prop-types';
import BellIcon from '@heroicons/react/24/solid/BellIcon';
import UsersIcon from '@heroicons/react/24/solid/UsersIcon';
import Bars3Icon from '@heroicons/react/24/solid/Bars3Icon';
import MagnifyingGlassIcon from '@heroicons/react/24/solid/MagnifyingGlassIcon';
import ReactLogo from '../../asserts/RaptorNet_color.svg';
import { ReactSVG } from 'react-svg';
import {
  Avatar,
  Badge,
  Box,
  Chip,
  IconButton,
  Stack,
  SvgIcon,
  Tooltip,
  Typography,
  useMediaQuery
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { usePopover } from 'src/hooks/use-popover';
import { AccountPopover } from './account-popover';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import keys from '../../constants.js';

const SIDE_NAV_WIDTH = 280;
const TOP_NAV_HEIGHT = 84;

function safeParse(raw) {
  try { return JSON.parse(raw); } catch (e) { return null; }
}

export const TopNav = (props) => {
  const { onNavOpen } = props;
  const lgUp = useMediaQuery(function(theme){ return theme.breakpoints.up('lg'); });
  const accountPopover = usePopover();
  const navigate = useNavigate();

  const [deviceID, setDeviceID] = useState('');

  // user summary (from localStorage)
  const lsUser = safeParse(localStorage.getItem('userData')) || {};
  const name = lsUser && (lsUser.name || lsUser.fullName || lsUser.displayName) || '';
  const email = lsUser && lsUser.email ? String(lsUser.email) : '';
  const rolesArr = Array.isArray(lsUser && lsUser.roles)
    ? lsUser.roles
    : (lsUser && lsUser.role ? String(lsUser.role).split(',').map(function(s){ return s.trim(); }) : []);
  const primaryRole = rolesArr && rolesArr.length ? rolesArr[0] : '';
  const section = lsUser && lsUser.section ? String(lsUser.section) : '';
  const isSuperEmail = email.toLowerCase() === 'securityscreening@aischennai.org';
  const displayRole = isSuperEmail ? 'All Access' : primaryRole;
  const initials = name ? name.split(' ').map(function(p){ return p[0]; }).join('').substring(0, 2).toUpperCase() : '';

  useEffect(function(){}, []);

  return (
    <>
      <Box
        component='header'
        className='mainNavHeader'
        id='noPrint'
        sx={{
          backdropFilter: 'blur(6px)',
          backgroundColor: function(theme){ return alpha(theme.palette.background.default, 0.8); },
          position: 'sticky',
          left: {},
          top: 0,
          width: {},
          zIndex: function(theme){ return theme.zIndex.appBar; },
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          border: '1px solid rgba(0, 0, 0, 0.5)',
          zIndex: 500000
        }}
      >
        <Stack
          alignItems='center'
          direction='row'
          justifyContent='space-between'
          spacing={2}
          sx={{ minHeight: TOP_NAV_HEIGHT, px: 2 }}
        >
          {/* left: logo or hamburger */}
          <Stack alignItems='center' direction='row' spacing={2}>
            {lgUp && (
              <div
                style={{ textAlign: 'center', width: '150px', cursor: 'pointer' }}
                onClick={function(){ navigate('/dashboard'); }}
              >
                <ReactSVG src={ReactLogo} className='logo-svg' />
                <Typography
                  variant='body1'
                  color='primary'
                  style={{ position: 'relative', left: '33px', top: '-9px' }}
                >
                  {props.subText}
                </Typography>
              </div>
            )}
            {!lgUp && (
              <IconButton onClick={onNavOpen}>
                <SvgIcon fontSize='small'>
                  <Bars3Icon />
                </SvgIcon>
              </IconButton>
            )}
          </Stack>

          {/* center: logo for small screens */}
          <Stack
            alignItems='center'
            direction='row'
            spacing={2}
            style={{
              position: 'absolute',
              left: 'calc(50% - 83px)',
              top: props.subText ? '15px' : '23px'
            }}
          >
            {!lgUp && (
              <div
                style={{ textAlign: 'center', width: '150px', cursor: 'pointer' }}
                onClick={function(){ navigate('/dashboard'); }}
              >
                <ReactSVG src={ReactLogo} className='logo-svg' />
                <Typography
                  variant='body1'
                  color='primary'
                  style={{ position: 'relative', left: '33px', top: '-9px' }}
                >
                  {props.subText}
                </Typography>
              </div>
            )}
          </Stack>

          {/* right: user summary + avatar */}
          <Stack alignItems='center' direction='row' spacing={1.25}>
            <Box
              sx={{ display: { xs: 'none', sm: 'flex' }, flexDirection: 'column', alignItems: 'flex-end', mr: 1 }}
              onClick={accountPopover.handleOpen}
              style={{ cursor: 'pointer' }}
              title={email}
            >
              <Typography variant='subtitle2' noWrap>{name || 'User'}</Typography>
              {(displayRole || section) ? (
                <Stack direction='row' spacing={0.5}>
                  {displayRole ? <Chip size='small' label={displayRole} /> : null}
                  {section ? <Chip size='small' variant='outlined' label={section} /> : null}
                </Stack>
              ) : null}
            </Box>

            <Avatar
              onClick={accountPopover.handleOpen}
              ref={accountPopover.anchorRef}
              sx={{ cursor: 'pointer', height: 40, width: 40 }}
              src={lsUser && lsUser.picture ? lsUser.picture : undefined}
            >
              {lsUser && !lsUser.picture ? initials : null}
            </Avatar>
          </Stack>
        </Stack>
      </Box>

      <AccountPopover
        anchorEl={accountPopover.anchorRef.current}
        open={accountPopover.open}
        onClose={accountPopover.handleClose}
      />
    </>
  );
};

TopNav.propTypes = {
  onNavOpen: PropTypes.func
};
